/**
 * BuildAutomaton CLI behavior for ACP `session/request_permission` (not sent to the agent binary).
 * `dangerous` auto-approves each permission request on the bridge host.
 */

export const CLI_PERMISSION_MODE_DEFAULT = 'default' as const;
export const CLI_PERMISSION_MODE_DANGEROUS = 'dangerous' as const;

export const CLI_PERMISSION_MODES = [CLI_PERMISSION_MODE_DEFAULT, CLI_PERMISSION_MODE_DANGEROUS] as const;

export type CliPermissionMode = (typeof CLI_PERMISSION_MODES)[number];

/** User preference key (GET/PATCH `/api/users/me/preferences`). */
export const CLI_PERMISSION_MODE_LAST_PREF_KEY = 'cliBridgePermissionMode' as const;

export function normalizeCliPermissionModeInput(raw: unknown): CliPermissionMode {
  if (typeof raw !== 'string') return CLI_PERMISSION_MODE_DEFAULT;
  const t = raw.trim();
  if (t === CLI_PERMISSION_MODE_DANGEROUS) return CLI_PERMISSION_MODE_DANGEROUS;
  /** Legacy value in prefs or `agent_config`. */
  if (t === 'standard') return CLI_PERMISSION_MODE_DEFAULT;
  return CLI_PERMISSION_MODE_DEFAULT;
}
